// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_MEDIA_QUERIES = {
  mobile: '(min-width: 320px) and (max-width: 768px)', // mobile-tablet
  desktop: '(min-width: 769px)', // desktop
};
